import { useEffect } from "react";
import { io } from "socket.io-client";

let socket; // singleton بسيط

export default function useSocket(id) {
    useEffect(() => {
        if (!id) return;

        if (!socket) {
            const current_path = "https://zoneapp.tech/";

            socket = io(current_path, {
                transports: ["websocket"]
            });

            socket.on("connect", () => {
                console.log("connect:", socket.id);
            });
        }

        socket.emit("register", id);

        return () => {
            // optional: مش لازم disconnect هنا في أغلب الحالات
        };
    }, [id]);

    return socket;
}